import { getFramework, IFramework } from '@/framework';
import { CROP_BACKGROUND_EVENTS } from './event-name';

export class CropBackground {
    private framework: IFramework;

    constructor(id: string) {
        this.framework = getFramework(id);
    }

    /** 打开裁剪 */
    open() {
        const originIndex = this.framework.stage.getActiveOriginIndex();
        const backgroundLayer = this.framework.getBackgroundLayer(originIndex);
        if (!backgroundLayer) return;
        this.framework.stage.addOrUpdate({
            ...backgroundLayer,
            __isCropImage: true,
        });
        this.framework.operate.disablePick(false);
        this.framework.events.emit(CROP_BACKGROUND_EVENTS.CROP_OPEN);
    }

    /** 关闭裁剪 */
    close() {
        const originIndex = this.framework.stage.getActiveOriginIndex();
        const backgroundLayer = this.framework.getBackgroundLayer(originIndex);
        if (!backgroundLayer) return;
        this.framework.stage.addOrUpdate({
            ...backgroundLayer,
            __isCropImage: false,
        });
        this.framework.operate.enablePick();
        this.framework.events.emit(CROP_BACKGROUND_EVENTS.CROP_CLOSE);
    }

    /** 监听裁剪取消 */
    onCancel(fn: () => void) {
        return this.framework.events.on(CROP_BACKGROUND_EVENTS.CROP_CANCEL, fn);
    }

    /** 监听裁剪确认 */
    onConfirm(fn: () => void) {
        return this.framework.events.on(CROP_BACKGROUND_EVENTS.CROP_CONFIRM, fn);
    }
}
